var _rect, _rect2, _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgPlaceholderArticle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 164,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 164,
    fill: "#FDF4F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 158,
    height: 162,
    fill: "none",
    stroke: "#EF8E92",
    strokeWidth: 1,
    strokeDasharray: "5,5"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 72,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "Bogle,Arial,sans-serif",
    fontSize: 10,
    fontWeight: "bold",
    fill: "#DE1C24"
  }, "Replace with")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 88,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "Bogle,Arial,sans-serif",
    fontSize: 10,
    fontWeight: "bold",
    fill: "#DE1C24"
  }, "an image.")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 108,
    textAnchor: "middle",
    dominantBaseline: "middle",
    fontFamily: "Bogle,Arial,sans-serif",
    fontSize: 10,
    fontWeight: "bold",
    fill: "#DE1C24"
  }, "(Max: 320 x 328px)")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPlaceholderArticle);
export default __webpack_public_path__ + "static/media/img-placeholder-article.ebfa77f2fedfcfd1bd63f887b7cefecd.svg";
export { ForwardRef as ReactComponent };